var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 45,
    viewBox: "0 0 27 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.673928 22.4999C0.673928 21.6934 0.981864 20.887 1.59644 20.2721L20.9456 0.923136C22.1765 -0.307712 24.1721 -0.307712 25.4024 0.923136C26.6328 2.15349 26.6328 4.1487 25.4024 5.37965L8.2812 22.4999L25.4018 39.6202C26.6322 40.8511 26.6322 42.8461 25.4018 44.0763C24.1715 45.3078 22.1759 45.3078 20.945 44.0763L1.59584 24.7276C0.981166 24.1125 0.673928 23.3061 0.673928 22.4999Z",
    fill: "#181A20",
    stroke: "#181A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.9d61693dfa8e30855108405d5ea64ebe.svg";
export { ForwardRef as ReactComponent };